
<script setup>

  import { ref, watch, onMounted } from 'vue';

  import { ArrowRightCircleIcon } from '@heroicons/vue/24/outline';

  import { seenPlayerDialog } from '../stores/activity-4.js';

  import backgroundPath from '../images/people-background.jpg';

  const ready = ref( false );

  onMounted( () => {

    watch( seenPlayerDialog, () => {

      if ( seenPlayerDialog.value ) setTimeout( () => ready.value = true, 100 );

    }, { immediate: true } );

  } );

</script>

<template>

  <article>

    <div class="grid items-center justify-center min-h-view bg-fixed bg-cover bg-center"
    
      :style="{ backgroundImage: `url( ${ backgroundPath } )` }">

      <div class="p-6 md:p-12 lg:p-24">

        <div class="max-w-xl">

          <h2 class="pb-6 border-b-[3px] border-black">

            <div class="text-xl tracking-narrow font-semibold uppercase">Activity 4</div>

            <div class="text-5xl font-heading uppercase">Identifying Agents of Change</div>

          </h2>

          <p class="mt-8 leading-7 text-neutral-700">

            History is like putting together puzzle pieces to see the bigger picture.
            
            Every event, big or small, plays a part in creating change.
            
            Things like new ideas, culture shifts, and politics all mix together and influence each other.
            
            They come together to make the world different.

          </p>

          <h3 class="mt-8 text-3xl font-medium font-serif italic">About This Activity</h3>

          <p class="mt-4 leading-7 text-neutral-700">

            Explore the interactive timeline of events in the history of the segregation and integration of
            
            Shenandoah National Park, then write about three key moments that affected change.

          </p>

          <div class="flex gap-6 flex-wrap mt-12">

            <RouterLink
            
              class="inline-flex items-center gap-4 px-6 py-4 text-white font-bold bg-green-700 transition-colors
              
                hover:bg-green-800 focus-visible:bg-green-800 hover:underline focus-visible:underline"
            
              to="/activity/4/part/1">

              <span>Part 1: Timeline</span>

              <ArrowRightCircleIcon class="w-8" />

            </RouterLink>

          </div>

        </div>

      </div>

    </div>

  </article>

</template>
